var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:_vm.containerClasses},_vm._l((_vm.postIds),function(postId){return _c('VPostPreview',{key:`post-${postId}`,class:_vm.$style.post,attrs:{"post":_vm.visiblePosts[postId]},on:{"click":_vm.onPostClick}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }